import { Filter, Filters, Value } from "PFTypes";

export enum ExportType {
  Template = "template",
  Custom = "custom"
}

export enum ReportType {
  Overall = "overall",
  Profiles = "profiles",
  ProfilesWithCategory = "profilesWithCategory",
  Activities = "activities",
  ActivitiesWithCategory = "activitiesWithCategory"
}

export enum Frequency {
  Daily = "daily",
  Weekly = "weekly",
  Monthly = "monthly"
}

export enum ScheduleFrequency {
  No = "no",
  Daily = "daily",
  Weekly = "weekly",
  Monthly = "monthly"
}

export type ExportField = {
  id?: string;
  title: string;
  value?: string;
};

export type ExportFields = Record<string, ExportField>;
export type ExportCategories = Record<string, ExportFields>;

export type ExportFilterGroups<T extends Filter | Value = Filter> = Record<string, Filters<T>>;
